"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { MemesSingleWaveDropInfoPanel } from "./MemesSingleWaveDropInfoPanel";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface MemesSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const MemesSingleWaveDrop: React.FC<MemesSingleWaveDropProps> = t0 => {
  const $ = _c(8);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t1;
  if ($[0] !== extendedDrop || $[1] !== wave) {
    t1 = <MemesSingleWaveDropInfoPanel drop={extendedDrop} wave={wave} />;
    $[0] = extendedDrop;
    $[1] = wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== drop || $[4] !== onClose || $[5] !== t1 || $[6] !== wave) {
    t2 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose}>{t1}</SingleWaveDropWrapper>;
    $[3] = drop;
    $[4] = onClose;
    $[5] = t1;
    $[6] = wave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};